module.exports = __webpack_public_path__ + "img/facebook.a653400d.svg";